// extracted by mini-css-extract-plugin
export default {"item":"SideCartItem_item__DpaFA"};